import { render, staticRenderFns } from "./MsTextBorder.vue?vue&type=template&id=8d0b1746&scoped=true"
import script from "./MsTextBorder.vue?vue&type=script&lang=js"
export * from "./MsTextBorder.vue?vue&type=script&lang=js"
import style0 from "./MsTextBorder.vue?vue&type=style&index=0&id=8d0b1746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0b1746",
  null
  
)

export default component.exports